// Activated-ability intent builders (server-authoritative once-per-turn gating,
// P7). Returns a { domain:'ability', kind:'activate', ... } object the server's
// match:intent handler routes into abilityService. Keep payload shapes in
// lockstep with valkenhall-server/src/match/abilityService.js.
//
// The server owns the once-per-turn GATE + the durable used-marker
// (card.abilitiesUsedThisTurn, the same field the client already folds). The
// ability's COST (resource intents) and its RESOLUTION (cell picks, target halos,
// SET_* state) stay on their existing paths. This intent only makes the gating
// decision authoritative so a tampered client cannot activate a once-per-turn
// ability twice.

let _seq = 0;
// A client-generated idempotency key so a re-sent activation (reconnect replay,
// double-send) is deduped on the SERVER spine, never via a client-local Set.
function nextKey(cardId, abilityKey) {
  _seq += 1;
  return `abil-${cardId}-${abilityKey}-${Date.now()}-${_seq}`;
}

// `abilityKey` is the client's `_oncePerTurnKey(entry)` (entry.id / _builtin /
// 'activated'); `oncePerTurn` is entry.once_per_turn. A repeatable ability still
// emits (the server records nothing) so the spine stays uniform. `extras`
// carries bespoke payload fields the server validates (Avatar of Fire's
// fireball_shot names its fire-site cost via `discardCardId`. The SERVER pays
// the hand → cemetery discard off the intent).
export function activateAbilityIntent(cardId, abilityKey, oncePerTurn, extras = {}) {
  return {
    domain: 'ability',
    kind: 'activate',
    cardId,
    abilityKey,
    oncePerTurn: !!oncePerTurn,
    ...extras,
    idempotencyKey: nextKey(cardId, abilityKey),
  };
}
